module.exports = __webpack_public_path__ + "img/logout.2dc2731b.svg";